import type { UpdateVacationRequest } from '@lunya/contracts'

import { toIsoDate } from '../../utils'

export type UpdateVacationInput = {
  /** `null` — выключить отпуск сразу, без подтверждения (спека 07 §2.2). */
  until: Date | null
}

/**
 * Выбранная дата → тело `PATCH /users/me/vacation`.
 *
 * Контракт ждёт дату без времени (`YYYY-MM-DD`, `isoDateSchema`). Раньше здесь стоял
 * `toISOString()`: он отдавал момент с временем и в UTC, ручка отвечала 422, а мутация глотала
 * ошибку — снаружи включение отпуска выглядело как «ничего не произошло».
 */
export function mapVacationToApi(input: UpdateVacationInput): UpdateVacationRequest {
  return { until: input.until ? toIsoDate(input.until) : null }
}
